import React, { useEffect, useState } from 'react';
import {
	Box,
	Flex,
	Text,
	Input,
	InputRightElement,
	InputGroup,
	Button,
	useToast,
	Avatar,
	Divider,
	Tabs,
	TabList,
	TabPanels,
	Tab,
	TabPanel,
	SimpleGrid,
	ModalOverlay,
	ModalContent,
	ModalBody,
	Modal,
	ModalCloseButton,
	ModalHeader,
	Accordion,
	AccordionItem,
	AccordionButton,
	AccordionPanel,
	AccordionIcon,
} from '@chakra-ui/react';
import c from '../../constant';
import { gql, useLazyQuery } from '@apollo/client';
import './style.css';
import { useTranslation } from 'react-i18next';
import useStore from '../../store';
import _ from 'lodash';

const limit = 99999;
const QUERY_USERS = gql`
query getUsers($offset:Float, $name: String){
    getUsersAll(
        pagerInput:{
            limit:${limit}
            offset:$offset
        }
        name: $name
        active: true,
    ){
      users{
        id
        username
        fullName
        fullNameKhmer
        createdAt
        avatar
        active
		office
		department
		position
        canApproveMissionRecord
      }
      totalPages
    }
  }
`;

function SelectUserAllModal({ cached = true, onClose = () => null, callback = () => null }) {
	const { t } = useTranslation();
	const toast = useToast();
	let currentPage = 0;
	const [loadUsers, { error, loading, data }] = useLazyQuery(QUERY_USERS);
	const [username, setUsername] = useState('');
	const [searchList, setSearchList] = useState([]);
	const { currentLang } = useStore((state) => state.currentLang);
	const { currentUser } = useStore((state) => state.currentUser);

	const [allUsers, setAllUsers] = useState([]);
	const [myOfficeUser, setMyOfficeUser] = useState([]);
	const [myDepartmentInCrontroll, setMyDepartmentInCrontroll] = useState([]);

	useEffect(() => {
		if (data) {
			sessionStorage.setItem('allUser', JSON.stringify(data?.getUsersAll?.users));
			processUser(data?.getUsersAll?.users);
		}
	}, [data]);

	useEffect(() => {
		if (cached === true) {
			let allUser = sessionStorage.getItem('allUser');
			if (allUser) {
				allUser = JSON.parse(allUser);
			}
			if (allUser?.length > 0) {
				processUser(allUser);
			} else {
				loadUserWithVar();
			}
		} else {
			loadUserWithVar();
		}
	}, []);

	function processUser(users) {
		setAllUsers(users);
		let myOfficeUsers = users.filter((e) => e?.office === currentUser?.office && e?.department?.includes(currentUser?.department));
		myOfficeUsers = _.orderBy(myOfficeUsers, ['position', 'createdAt'], ['asc', 'asc']);
		setMyOfficeUser(myOfficeUsers);

		let myDepartment = currentUser?.department?.split(',');
		let tempMyDepartmentInCrontroll = [];
		myDepartment?.map((dp) => {
			c.departments?.map((allDp) => {
				if (dp === allDp?.value) {
					tempMyDepartmentInCrontroll.push(allDp);
				}
			});
		});
		setMyDepartmentInCrontroll(tempMyDepartmentInCrontroll);
	}

	function getUserByOfficeAndDepartment(users, office, department) {
		let myOfficeUsers = users.filter((e) => e?.office === office && e?.department?.includes(department));
		myOfficeUsers = _.orderBy(myOfficeUsers, ['position', 'createdAt'], ['asc', 'asc']);
		return myOfficeUsers;
	}

	const handleKeyDown = (event) => {
		if (event.key === 'Enter') {
			handleSearch();
		}
	};

	function handleSearch() {
		if (username) {
			const list = allUsers?.filter((e) => {
				return (
					(e?.username?.toLowerCase() || '').includes(username) ||
					(e?.fullName?.toLowerCase() || '').includes(username) ||
					(e?.fullNameKhmer?.toLowerCase() || '').includes(username)
				);
			});
			setSearchList(_.orderBy(list, ['position', 'createdAt'], ['asc', 'asc']));
		} else {
			setSearchList([]);
		}
	}

	function loadUserWithVar() {
		loadUsers({
			variables: {
				offset: currentPage ? (currentPage - 1) * limit : 0,
				name: username,
				// departments,
				// offices,
			},
		});
	}

	function getDisplayName(user) {
		let displayName = user?.username;
		if (currentLang === 'kh') {
			displayName = user?.fullNameKhmer ? user?.fullNameKhmer : user?.fullName ? user?.fullName : user?.username;
		} else {
			displayName = user?.fullName ? user?.fullName : user?.fullNameKhmer ? user?.fullNameKhmer : user?.username;
		}
		return displayName;
	}

	function getDisplayName(user) {
		let result = user?.username;
		if (currentLang === 'kh') {
			if ((result = user?.fullNameKhmer)) {
				result = user?.fullNameKhmer;
			} else {
				if (user?.fullName) {
					result = user?.fullName;
				} else {
					result = user.username;
				}
			}
		} else {
			if ((result = user?.fullName)) {
				result = user?.fullName;
			} else {
				if (user?.fullNameKhmer) {
					result = user?.fullNameKhmer;
				} else {
					result = user.username;
				}
			}
		}

		return result;
	}

	function getSpecificUser(allUsers, list) {
		let tempList = [];
		list?.map((username) => {
			let user = allUsers?.filter((e) => e?.username === username);
			if (user?.length > 0) {
				tempList.push(user[0]);
			}
		});
		return tempList;
	}

	function userBox(item, index) {
		return (
			<Flex
				onMouseDown={() => {
					callback(item);
				}}
				cursor={'pointer'}
				mb="2"
				borderRadius={c.borderRadius}
				key={index}
				alignItems="center"
				_hover={{ bg: 'gray.100', border: '1px solid #34495e' }}
				p="2"
				border="1px solid #bdc3c7"
			>
				<Avatar size="xs" name={getDisplayName(item)} src={item?.avatar?.icon ? c.baseFilePath + item?.avatar?.icon : null} />
				<Text ml="2" textAlign="left" noOfLines={3} fontWeight="bold">
					{getDisplayName(item)}
				</Text>
			</Flex>
		);
	}

	function userBoxImportant(item, index) {
		return (
			<Flex
				onMouseDown={() => {
					callback(item);
				}}
				cursor={'pointer'}
				mb="2"
				borderRadius={c.borderRadius}
				key={index}
				alignItems="center"
				_hover={{ bg: 'gray.100', border: '1px solid #34495e' }}
				p="2"
				border="1px solid #bdc3c7"
			>
				<Avatar size="md" name={getDisplayName(item)} src={item?.avatar?.medium ? c.baseFilePath + item?.avatar?.medium : null} />
				<Text ml="2" fontSize="md" textAlign="left" noOfLines={3} fontWeight="bold">
					{getDisplayName(item)}
				</Text>
			</Flex>
		);
	}

	function canViewByPosition(list) {
		let canView = false;
		list?.map((item) => {
			if (item === parseInt(currentUser.position)) {
				canView = true;
			}
		});
		return canView;
	}

	return (
		<Modal
			onClose={() => {
				onClose();
			}}
			size="4xl"
			isOpen={true}
		>
			<ModalOverlay />
			<ModalContent borderRadius={c.borderRadius}>
				<ModalHeader>
					<InputGroup size="md">
						<Input
							onKeyDown={handleKeyDown}
							autoFocus
							w="283px"
							pr="4.5rem"
							placeholder={t('Name')}
							value={username}
							onChange={(e) => setUsername(e.target.value)}
						/>
						<InputRightElement zIndex={0} width="4.5rem"></InputRightElement>
						<Button size="md" ml="2" onClick={handleSearch}>
							{t('Search')}
						</Button>
					</InputGroup>
				</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					{loading && <Text>Loading...</Text>}
					<Box>
						{searchList?.length > 0 && (
							<SimpleGrid columns={[2, null, 3]} spacing="10px">
								{searchList?.map((item, index) => userBox(item, index))}
							</SimpleGrid>
						)}
						{searchList?.length <= 0 && (
							<Tabs isFitted variant="enclosed">
								<TabList mb="1em">
									{canViewByPosition([8, 7, 6, 5]) && <Tab>{t('Office')}</Tab>}
									{canViewByPosition([8, 7, 6, 5, 4, 3, 2]) && <Tab>{t('Department')}</Tab>}
									<Tab>{t('IRC')}</Tab>
								</TabList>
								<TabPanels>
									{canViewByPosition([8, 7, 6, 5]) && (
										<TabPanel>
											<SimpleGrid columns={[2, null, 3]} spacing="20px">
												{myOfficeUser?.map((item, index) => userBox(item, index))}
											</SimpleGrid>
										</TabPanel>
									)}
									{canViewByPosition([8, 7, 6, 5, 4, 3, 2]) && (
										<TabPanel>
											{myDepartmentInCrontroll?.map((item, index) => {
												return (
													<Box key={index}>
														<Text fontSize="lg" fontWeight="bold">
															{currentLang === 'kh' ? item?.labelKh : item?.label}
														</Text>
														<SimpleGrid mt="4" columns={[1, null, item?.offices?.length]} spacing="20px">
															{getUserByOfficeAndDepartment(allUsers, '', item?.value)?.map((u, k) => userBox(u, k))}
														</SimpleGrid>
														<Accordion allowMultiple>
															<AccordionItem>
																<h2>
																	<AccordionButton>
																		<Box as="span" flex="1" textAlign="left">
																			{t('Offices')}
																		</Box>
																		<AccordionIcon />
																	</AccordionButton>
																</h2>
																<AccordionPanel pb={4}>
																	<SimpleGrid mt="4" columns={[1, null, item?.offices?.length]} spacing="20px">
																		{item?.offices?.map((office, j) => {
																			return (
																				<Box key={j}>
																					<Text fontWeight="bold">
																						{currentLang === 'kh' ? office?.labelKh : office?.label}
																					</Text>
																					<Box mt="4">
																						{getUserByOfficeAndDepartment(
																							allUsers,
																							office?.value,
																							item?.value,
																						)?.map((u, k) => userBox(u, k))}
																					</Box>
																				</Box>
																			);
																		})}
																	</SimpleGrid>
																</AccordionPanel>
															</AccordionItem>
														</Accordion>
													</Box>
												);
											})}
										</TabPanel>
									)}
									<TabPanel>
										<SimpleGrid mt="2" mb="4" columns={[1, null, 3]} spacing="20px">
											{getSpecificUser(allUsers, ['bouchanphirou', 'horsovathana', 'tanlinna'])?.map((item, index) =>
												userBoxImportant(item, index),
											)}
										</SimpleGrid>
										<Accordion allowMultiple>
											<AccordionItem>
												<h2>
													<AccordionButton>
														<Box as="span" flex="1" textAlign="left">
															{t('Departments')}
														</Box>
														<AccordionIcon />
													</AccordionButton>
												</h2>
												<AccordionPanel pb={4}>
													{c.departments?.map((item, index) => {
														return (
															<Box key={index}>
																<Text fontSize="lg" fontWeight="bold">
																	{currentLang === 'kh' ? item?.labelKh : item?.label}
																</Text>
																<SimpleGrid mt="4" columns={[1, null, item?.offices?.length]} spacing="20px">
																	{getUserByOfficeAndDepartment(allUsers, '', item?.value)?.map((u, k) => userBox(u, k))}
																</SimpleGrid>
																<SimpleGrid mt="4" columns={[1, null, item?.offices?.length]} spacing="20px">
																	{item?.offices?.map((office, j) => {
																		return (
																			<Box key={j}>
																				<Text fontWeight="bold">
																					{currentLang === 'kh' ? office?.labelKh : office?.label}
																				</Text>
																				<Box mt="4">
																					{getUserByOfficeAndDepartment(allUsers, office?.value, item?.value)?.map(
																						(u, k) => userBox(u, k),
																					)}
																				</Box>
																			</Box>
																		);
																	})}
																</SimpleGrid>

																<Divider mt="4" mb="4" />
															</Box>
														);
													})}
												</AccordionPanel>
											</AccordionItem>
										</Accordion>
									</TabPanel>
								</TabPanels>
							</Tabs>
						)}
					</Box>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
}

export default SelectUserAllModal;
